// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"688":"943d0df9","951":"9ef8d54f"}[chunkId] + ".chunk.js";
};